import {
  Box,
  CircularProgress,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { MdRocketLaunch } from "react-icons/md";

import HocPopup from "../../../hoc/hocPopup";
import { IoInformationCircle } from "react-icons/io5";
import Theme from "../../../utils/Theme";
import { TYPE } from "../../../utils/Utils";
import ServicePopup from "./ServicePopup";
import { ServiceStyle } from "./ServiceStyle";
import { RiSendPlaneFill } from "react-icons/ri";
import { AiOutlineRedo } from "react-icons/ai";

const ServiceUtils = (props) => {
  const {
    dialog,
    data,
    isDisable = false,
    isRepull,
    handleChange,
    preference,
    service,
    setPreference,
    loading,
    ServiceName,
  } = props;

  console.log("ServiceUtils data", data);
  const handlePreference = (service, value) => {
    setPreference((prev) => ({
      ...prev,
      [service]: value,
    }));
  };

  return (
    <Box sx={ServiceStyle.listMainBox}>
      <Box sx={ServiceStyle.informationBox}>
        <IoInformationCircle
          size={24} 
          style={{ cursor: "pointer", flexShrink: 0 }}
          color={Theme.palette.primary.main}
          onClick={() => {
            dialog({
              open: true,
              bodyType: TYPE.SERVICES,
              body: <ServicePopup data={data} ServiceName={ServiceName} />,
               maxWidth: "sm",
              fullScreen: true,
            });
          }}
        />
        <Typography>{ServiceName}</Typography>
      </Box>
      <Box
        sx={{
          ...ServiceStyle.launchIconBox,
          pointerEvents: isDisable ? "none" : false,
          opacity: isDisable ? 0.6 : false,
        }}
      >
        <FormControl variant="outlined" sx={{ width: "100%" }}>
          <Select
            value={preference}
            onChange={(e) => {
              handlePreference(service, e.target.value);
            }}
            sx={{
              "& .MuiSelect-select": {
                py: 1,
              },
            }}
          >
            <MenuItem value={3}>Device</MenuItem>
            <MenuItem value={2}>Text</MenuItem>
            <MenuItem value={1}>Email</MenuItem>
            <MenuItem value={0}>Select</MenuItem>
          </Select>
        </FormControl>
        <IconButton
          onClick={() => {
            handleChange(service);
          }}
        >
          {!isRepull ? (
            <Box
              sx={preference === 0 && { pointerEvents: "none", opacity: 0.5 }}
            >
              <RiSendPlaneFill size={25} color={Theme.palette.primary.main} />
            </Box>
          ) : loading ? (
            <CircularProgress />
          ) : (
            <Box
              sx={preference === 0 && { pointerEvents: "none", opacity: 0.5 }}
            >
              <AiOutlineRedo size={25} color={Theme.palette.primary.main} />
            </Box>
          )}
        </IconButton>
      </Box>
    </Box>
  );
};
export default HocPopup(ServiceUtils);